import { useEffect } from "react";
import "./App.css";
import Header from "./components/Header";
import Footer from "./components/Footer";
import Portal from "./components/Portal";
import Override from "./components/Override";
import InfoPage from "./components/InfoPage";
import Reactions from "./components/Reactions";
import Dashboard from "./components/Dashboard";
import AdminLogin from "./components/AdminLogin";
import LanguageSelect from "./components/LanguageSelect";
import ProtectedRoute from "./components/ProtectedRoute";
import CompletionPage from "./components/CompletionPage";
import RegistrationPage from "./components/RegistrationPage";
import { AppRoutes, LocalStorageKeys } from "./constants";
import { useAppDispatch, useAppSelector } from "./redux";
import {
  selectError,
  selectSuccess,
  selectIsLoading,
  selectIsLoggedIn,
  getAppInfoAction,
  selectUnderConstruction,
} from "./AppSlice";
import {
  selectIsInitialLanguage,
  setCurrentLanguageFromOverride,
} from "./components/LanguageSelect/LanguageSelectSlice";
import { Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Maintenance } from "./components/Maintenance/Maintenance";
import type { Language } from "./types";

function App() {
  const location = useLocation();

  const error = useAppSelector(selectError);
  const success = useAppSelector(selectSuccess);
  const isLoading = useAppSelector(selectIsLoading);
  const isLoggedIn = useAppSelector(selectIsLoggedIn);
  const underConstractions = useAppSelector(selectUnderConstruction);
  const isInitialLanguage = useAppSelector(selectIsInitialLanguage);

  const dispatch = useAppDispatch();

  useEffect(() => {
    const start = async () => {
      async function getData() {
        await dispatch(getAppInfoAction());
      }

      await getData();
    };

    start();

    const params = new URLSearchParams(location.search);

    const language = params.get("language");

    if (language && !isInitialLanguage) dispatch(setCurrentLanguageFromOverride(language as Language));
    else if (!isInitialLanguage) {
      const savedLanguage = localStorage.getItem(LocalStorageKeys.language);

      if (savedLanguage) dispatch(setCurrentLanguageFromOverride(savedLanguage as Language));
    }
  }, []);

  return (
    <>
      <Reactions error={error} success={success} isLoading={isLoading} />
      {location.pathname.includes("admin") ? null : (
        <>
          <Header />

          <LanguageSelect />
        </>
      )}

      <Routes>
        <Route index element={underConstractions ? <Maintenance /> : <RegistrationPage />} />

        <Route path={AppRoutes.overrideAttempts} element={<Override />} />

        <Route path={AppRoutes.home} element={underConstractions ? <Maintenance /> : <RegistrationPage />} />

        <Route path={AppRoutes.portal} element={<Portal />} />

        <Route path={AppRoutes.infoPage} element={<InfoPage />} />

        <Route path={AppRoutes.completion} element={<CompletionPage />} />

        <Route path={AppRoutes.adminLogin} element={<AdminLogin />} />

        <Route
          path={AppRoutes.adminPanel}
          element={
            <ProtectedRoute isLoggedIn={isLoggedIn}>
              <Dashboard />
            </ProtectedRoute>
          }
        />

        <Route path="*" element={<Navigate to={AppRoutes.home} replace />} />
      </Routes>

      <Footer />
    </>
  );
}

export default App;
